/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Modal, Input, Table, message, Tag } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import ProformaService from "../../../../service/ERP/Proforma.service";

const piService = ProformaService();

const money = (v) =>
  Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** เลือกใบ Invoice เพื่อดึงมาสร้าง Proforma Invoice (วิธีที่ 2) */
export default function ModalPickInvoice({ open, close, confirm }) {
  const [rows, setRows] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setKeyword("");
    setLoading(true);
    piService
      .availableInvoices("")
      .then((res) => setRows(res.data?.data || []))
      .catch(() => message.error("โหลดรายการ Invoice ไม่สำเร็จ"))
      .finally(() => setLoading(false));
  }, [open]);

  const data = useMemo(() => {
    const k = keyword.trim().toLowerCase();
    if (!k) return rows;
    return rows.filter((r) =>
      [r.inv_code, r.cusname, r.brand]
        .filter(Boolean)
        .some((v) => String(v).toLowerCase().includes(k))
    );
  }, [rows, keyword]);

  const columns = [
    { title: "เลขที่ Invoice", dataIndex: "inv_code", width: 140 },
    {
      title: "วันที่",
      dataIndex: "inv_date",
      width: 110,
      align: "center",
      render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
    },
    { title: "ลูกค้า", dataIndex: "cusname" },
    { title: "Brand", dataIndex: "brand", width: 140 },
    {
      title: "ยอดรวม",
      dataIndex: "total_amount",
      width: 130,
      align: "right",
      render: (v, r) => `${r.currency || ""} ${money(v)}`,
    },
    {
      title: "เลขรัน",
      dataIndex: "runno",
      width: 90,
      align: "center",
      render: (v) => (v ? <Tag color="blue">{String(v).padStart(4, "0")}</Tag> : <Tag>-</Tag>),
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={() => close?.(false)}
      footer={null}
      width={960}
      title="เลือก Invoice ที่จะดึงมาสร้าง Proforma Invoice"
      destroyOnClose
    >
      <Input
        allowClear
        prefix={<SearchOutlined />}
        placeholder="ค้นหาเลขที่ Invoice / ลูกค้า / brand"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        className="!mb-3"
      />
      <Table
        size="small"
        rowKey="inv_code"
        loading={loading}
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 10, showSizeChanger: false }}
        scroll={{ y: 360 }}
        onRow={(record) => ({
          onClick: () => {
            confirm?.(record);
            close?.(false);
          },
          style: { cursor: "pointer" },
        })}
      />
    </Modal>
  );
}
